'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';

import projectChronology from './module/project_chronology';

export default angular.module('investmentProject.reports', [projectChronology])
    .name;
